var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"eoc-status text-white",attrs:{"variant":_vm.statusVariant}},[_vm._v("\n  "+_vm._s(_vm.statusText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }